import React from 'react';
import queryString from 'query-string';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Tables } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';
import { TemplateType } from 'store/modules/organizations/organizations';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import Template from './Template';

const { TablePagination, Table, TableBody, TableHeader, TableFooter } = Tables;
const { withRouter } = RouterProvider;

interface TemplateListProps extends RouteComponentProps {
  list: Array<any>;
  count: number;
  currentPage: number;
  singleUrl: string;
  createUrl: string;
  removeTemplate: (id: number) => void;
}

const TemplatesList = ({
  list,
  count,
  currentPage,
  history,
  singleUrl,
  createUrl,
  removeTemplate,
}: TemplateListProps) => {
  const t = useFormatMessage();

  const onChangePage = (page: number) => {
    const params = { limit: 20, offset: 20 * page - 20 };
    history.push(`${singleUrl}?${queryString.stringify(params)}`);
  };

  return (
    <>
      <Button color="primary" onClick={() => history.push(createUrl)} mb="2rem">
        {t('dashboard.template.new', 'New Template')}
      </Button>

      <Table>
        <TableHeader
          cells={[
            t('dashboard.templates.name', 'Name'),
            t('dashboard.templates.status', 'Status'),
            {
              text: t('dashboard.templates.actions', 'Actions'),
              props: { align: 'right' },
            },
          ]}
        />

        <TableBody>
          {list.map((template: TemplateType) => (
            <Template
              key={template.id}
              id={template.id}
              active={template.active}
              name={template.name}
              singleUrl={singleUrl}
              removeTemplate={removeTemplate}
            />
          ))}
        </TableBody>
        <TableFooter>
          <TablePagination
            count={count}
            currentPage={currentPage}
            rowsPerPage={20}
            onChangePage={onChangePage}
          />
        </TableFooter>
      </Table>
    </>
  );
};

export default withRouter(TemplatesList);
